import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2384e94c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "cost" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Die Immobilienbewertung von immowelt ist komplett kostenlos und unverbindlich. Sachverständige hingegen verlangen mindestens 0,5 Prozent des Verkaufspreises für ihre Einschätzung des Marktwerts. ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Gut zu wissen:"),
  /*#__PURE__*/_createTextVNode(" Auch Makler können für eine etwas genauere Werteinschätzung zur Besichtigung vor Ort eingeladen werden. Für diesen Service verlangen Immobilienmakler in der Regel erst noch nichts. ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_info_box = _resolveComponent("info-box")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_info_box, { title: "Was kostet die Immobilienbewertung von immowelt?" }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3
      ]),
      _: 1
    })
  ]))
}